import React, { Fragment } from 'react';
import { useContext } from 'react';
import { HelpCenterContext } from './Context/HelpCenterContext';
import { CommanArticles } from './Data';
export const VideoArticleLists = (props) => {
    const { state, dispatch } = useContext(HelpCenterContext)
    const { heading } = props
    let data = []
    if (heading === "Relevant Topics") {
        data = state.dataItem.Article
    }
    if (heading === "Other helpful resources") {
        data = CommanArticles
    }
    return (
        <div className="my-3">
            <strong>{heading}</strong>
            <Fragment>
                {data.map(item => (
                    <div className='my-1'>
                        {item.externalUrl ?
                            <a href={item.externalUrl} target="_blank" className='text-secondary' rel="noreferrer"><i className="fa-solid fa-arrow-right me-3"></i>{item.text}</a>
                            :
                            <span onClick={() => dispatch({ type: "TOGGLE_DETAIL_COMPONENT", payload: item })} className='text-secondary font-size-0 topic-links'><i className="fa-solid fa-arrow-right me-3"></i>{item.text}</span>
                        }
                    </div>
                ))}
            </Fragment>
        </div>
    )
}